import style from "./About2.module.css";
import about2title1 from "../../assets/images/about2title1.png";
import jiagou from "../../assets/images/jiagou.png";
import about2title2 from "../../assets/images/about2title2.png";
import { useState, useEffect } from "react";
import avatar1 from "../../assets/images/avatar/1.png";
import avatar2 from "../../assets/images/avatar/2.png";
import avatar3 from "../../assets/images/avatar/3.png";
import avatar4 from "../../assets/images/avatar/4.png";
import avatar5 from "../../assets/images/avatar/5.png";
import request from "../../common/request";

export default function Main() {
  const [list, setList] = useState([]);
  useEffect(() => {
    request.getColumnList("精英团队").then((result) => {
      console.log(result.data);
      if (result.data.data.data && result.data.data.data.length > 0) {
        var data = result.data.data.data;
        setList(data);
      }
      console.log("list", data);
    });
  }, []);

  return (
    <>
      <div className={style.sec1}>
        <img src={about2title1} className={style.title1} />
        <div className={"div20"}></div>
        <div className={style.jiagoubox}>
          <img src={jiagou} style={{ width: "950px" }} />
        </div>

        <div className={"div50"}></div>
      </div>
      <div className={style.sec2}>
        <img src={about2title2} />

        {list.map((item, index) => {
          return (
            <div className={style.list}>
              <div>
                <img src={item.pic} />
                <h1>{item.title}</h1>
                <p>{item.content}</p>
              </div>
            </div>
          );
        })}
        {/* <div className={style.list}>
          <div>
            <img src={avatar2} />
            <h1>詹新峰：总经理</h1>
            <p>
              公司总经理,上海财经大学金融专业本科,上海交通大学管理专业硕士研究生毕业。具有国有大型银行20年以上的专业从业经历。
            </p>
          </div>
        </div>
        <div className={style.list}>
          <div>
            <img src={avatar3} />
            <h1>王文标：副总经理</h1>
            <p>
              商管理本科毕业,浙江大学融资性担保专业高级工商管理研修班结业,营销师只称,曾获“温州市担保行业优秀员工”等荣誉称号,具有十多年丰富的中小企业的独资担保从业经验。
            </p>
          </div>
        </div>
        <div className={style.list}>
          <div>
            <img src={avatar4} />
            <h1>陈相钦：互联网金融部业务总监</h1>
            <p>
              浙大融资性担保机构经营管理高级研修班结业,持有浙江省融资担保行业从业资格证书,具有8年以上中小企业融资担保从业经验。
            </p>
          </div>
        </div>
        <div className={style.list}>
          <div>
            <img src={avatar5} />
            <h1>叶滨：工程保函部业务总监</h1>
            <p>
              具有10年以上融资担保和企业营销经验,被评为“担保行业优秀员工”称号。
            </p>
          </div>
        </div> */}
      </div>
    </>
  );
}
